import React, { useState, useEffect, useCallback } from 'react';
import './../../App.css';
import './../Personnel/Employees.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from '../CommonObjects';
import {SetAuditTrail} from './../Reports/AuditTrailReportEmployeeSetup';
import axios from 'axios';
import {token, domain, globalTimeFormat} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
import {useTable, useSortBy} from 'react-table';
// icons
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import SearchIcon from '@mui/icons-material/Search';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function PayrollJournalAccount({user, isHideSideMenu}) {
    var header = [
        "ID",
        "Description",
        "Types",
        "",
    ]
    var accessor = [
        "id",
        "description",
        "payrollJournalAccountTypes",
        "manage"
    ]

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [data, setData] = useState([]);
    // Retrieve
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [dataToFetch, setDataToFetch] = useState("");
    const [searchPlaceholder, setSearchPlaceholder] = useState("description");
    // Add
    const [showAddForm, setShowAddForm] = useState(false);
    const [description, setDescription] = useState("");
    const [payrollJournalAccountTypes, setPayrollJournalAccountTypes] = useState([]);
    //Update
    const [showEditForm, setShowEditForm] = useState(false);
    const [selectedData, setSelectedData] = useState(null);
    
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end
    
    const apiUrl = domain + "/api/PayrollJournalAccount";

    const fetchData = useCallback(async (dataToFetch) => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl + dataToFetch , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setData(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl]);

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("description")
                setDataToFetch("");
                break;
            case 1:
                setSearchPlaceholder("description")
                setDataToFetch("/active")
                break;
            case 2:
                setSearchPlaceholder("id")
                setDataToFetch("");
                break;
            default:
                setSearchPlaceholder("description")
                setDataToFetch("");
                break;
        }
        fetchData(dataToFetch);
        
    }, [filterDataIndex, dataToFetch, fetchData]);

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.description.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.description.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 2:
                res = filterData.filter((f) =>
                f.id.toString().startsWith(value)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.description.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setData(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            description: description,
            payrollJournalAccountTypes: payrollJournalAccountTypes
        };
        
        console.log('Final bulkData:', JSON.stringify(data, null, 2));

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowAddForm(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Payroll Journal Account", 
                actionTaken: "insert", 
                field: "Add", 
                newValue: `${data.description}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchData(""); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setDescription("");
            setPayrollJournalAccountTypes([]);
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAddForm(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            description: description,
            payrollJournalAccountTypes: payrollJournalAccountTypes
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/${selectedData.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setShowEditForm(false);
            await fetchData(""); // Assuming fetchData() fetches the updated data for the table

            console.log('Data updated successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);

            // Reload table data and reset form fields
            setDescription("");
            setPayrollJournalAccountTypes([]);
        } catch (error) {
            console.error('There was a problem updating data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditForm(false);
    };

    const addHandleClick = () => {
        setShowAddForm(true);
    };
    const editHandleClick = (data) => {
        setShowEditForm(true);
        setSelectedData(data);
        setDescription(data.description);
        setPayrollJournalAccountTypes(data.payrollJournalAccountTypes);
    };
    const closeAddHandleClick = () => {
        setShowAddForm(false);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="EmployeesTabInfo shadow-xl">
                        <div className="employeesTab-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Maintenance >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Payroll Journal Account"}</span>
                            </div>
                            <h3>Payroll Journal Account</h3>
                        </div>
                        <div className="employeesTab-body">
                            {Filter(setFilterDataIndex)}
                            <div className="body-top row">
                                <div className="body-top-search">
                                    {CreateSearchBarWithPlaceHolder("", 
                                                                        "mainte-search row", 
                                                                        "mainte-search-icon", 
                                                                        "mainte-search-input", 
                                                                        (e) => handleFilter(e.target.value), 
                                                                        "Search by " + searchPlaceholder, 
                                                                        SearchIcon)}
                                </div>
                                <div className="body-top-btn row" style={{justifyContent: "end"}}>
                                        {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                                </div>
                            </div>
                            <div className="employeesTab-table container">
                                <CreateTable
                                    dataList={data}
                                    dataHeader={header}
                                    dataAccessor={accessor}
                                    editHandleClick={editHandleClick}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddForm  isOpen={showAddForm} 
                    onClose={closeAddHandleClick}
                    description={description}
                    setDescription={setDescription}
                    payrollJournalAccountTypes={payrollJournalAccountTypes}
                    setPayrollJournalAccountTypes={setPayrollJournalAccountTypes}
                    handleSubmit={handleSubmit}
            >
            </AddForm>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    description={description}
                    setDescription={setDescription}
                    payrollJournalAccountTypes={payrollJournalAccountTypes}
                    setPayrollJournalAccountTypes={setPayrollJournalAccountTypes}
                    handleUpdate={handleUpdate}
            >
            </EditForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function TypeSelect({type, setType}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setType(event.target.value);
    };

    useEffect(() => {
        if(type !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [type]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={type} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose type</option>
            <option value="TotalBasic">TotalBasic</option>
            <option value="TotalGrossPay">TotalGrossPay</option>
            <option value="TotalNetPay">TotalNetPay</option>
            <option value="TotalAllowance">TotalAllowance</option>
            <option value="TotalBenefits">TotalBenefits</option>
            <option value="TotalOTRegular">TotalOTRegular</option>
            <option value="TotalOTRestday">TotalOTRestday</option>
            <option value="TotalOTHolidaySpecial">TotalOTHolidaySpecial</option>
            <option value="TotalOTHolidayRegular">TotalOTHolidayRegular</option>
            <option value="TotalOTRestdayHolidaySpecial">TotalOTRestdayHolidaySpecial</option>
            <option value="TotalOTRestdayHolidayRegular">TotalOTRestdayHolidayRegular</option>
            <option value="TotalNighDiff">TotalNighDiff</option>
            <option value="TotalLeaves">TotalLeaves</option>
            <option value="TotalDeduction">TotalDeduction</option>
            <option value="TotalAddition">TotalAddition</option>
            <option value="TotalAdjustment">TotalAdjustment</option>
            <option value="TotalSSS">TotalSSS</option>
            <option value="TotalPagibig">TotalPagibig</option>
            <option value="TotalPhilhealth">TotalPhilhealth</option>
            <option value="TotalTax">TotalTax</option>
            <option value="TotalUndertime">TotalUndertime</option>
            <option value="TotalLate">TotalLate</option>
            <option value="TotalAbsents">TotalAbsents</option>
            <option value="TotalPagibigCalamityLoan">TotalPagibigCalamityLoan</option>
            <option value="TotalPagibigLoan">TotalPagibigLoan</option>
            <option value="TotalSSSCalamityLoan">TotalSSSCalamityLoan</option>
            <option value="TotalSSSLoan">TotalSSSLoan</option>
            <option value="TotalCompanyLoan">TotalCompanyLoan</option>
            <option value="TotalCashAdvance">TotalCashAdvance</option>
            <option value="TotalOtherCashAdvance">TotalOtherCashAdvance</option>
            <option value="TotalRegularHolidays">TotalRegularHolidays</option>
            <option value="TotalSpecialNonWorkingHolidays">TotalSpecialNonWorkingHolidays</option>
            <option value="TotalNighDiffAmount">TotalNighDiffAmount</option>
            </select>
        </div>
    );
};
function AddForm({
    isOpen, 
    onClose,
    description,
    setDescription,
    payrollJournalAccountTypes,
    setPayrollJournalAccountTypes,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);
    const [type, setType] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const submit = (e) =>{
        if(!description){
            setErrorState(true);
            return;
        }

        if(payrollJournalAccountTypes.length <= 0){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage(`Please add a type`);
            return;
        }

        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setDescription("");
        setPayrollJournalAccountTypes([]);
        setErrorState(false);
        setIsAddState(false);
    };

    const [isAddState, setIsAddState] = useState(false);
    const addHandleClick = () => {
        setIsAddState(true);
    }
    const saveType = () =>{
        if(payrollJournalAccountTypes.find(i => i.description === type)){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage(`${type} is already added.`);
            return;
        }

        const data = {
            description: type
        }

        setPayrollJournalAccountTypes((prev) => [...prev, data])
        setType("");
        setIsAddState(false);
    }
    const cancelType = () =>{
        setIsAddState(false);
    }
    const removeType = (data) => {
        setPayrollJournalAccountTypes((prev) => prev.filter((i) => i.description !== data.description));
    };

    const generateType = () => {
        return payrollJournalAccountTypes.length > 0 
            ? payrollJournalAccountTypes.map((data) => (
                <div className="row" style={{alignItems: "center", margin: "5px 0"}}>
                    <span>{data.description}</span>
                    <button
                        id="add-family"
                        className="cancel row"
                        onClick={()=>removeType(data)}
                        style={{marginLeft: "10px", height: "20px"}}
                    >
                        remove
                    </button>
                </div>
            ))
            : <span>No type selected</span>;
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Account</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Description</div>
                            <div className="info-item-input">
                                <input
                                id="description"
                                placeholder="Description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !description && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>

                        <div className="popUp-item info-item">
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Types</div>
                            <div className="info-item-input column" style={{padding: "10px"}}>
                                {generateType()}
                            </div>
                        </div>

                        <>
                            {!isAddState &&
                                <button
                                    id="add-family"
                                    className="add row"
                                    onClick={()=>addHandleClick()}
                                >
                                    Add Type
                                </button>
                            }

                            { isAddState &&
                                <>
                                    <div className="popUp-item info-item column">
                                        <div className="info-item-label">Types</div>
                                        <div className="info-item-input">
                                            <TypeSelect type={type} setType={setType}/>
                                        </div>
                                        <span style={{
                                                visibility: (!type && errorState) ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>{"Please fill up this field"}
                                        </span>
                                    </div>
                                    <div className="row">
                                        <button
                                            id="add-family"
                                            className="save row"
                                            onClick={()=>saveType()}
                                        >
                                            Save
                                        </button>
                                        <button
                                            id="add-family"
                                            className="cancel row"
                                            onClick={()=>cancelType()}
                                            style={{marginLeft: "5px"}}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </>
                            }
                        </>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
        </>
    );
}
function EditForm({
    isOpen, 
    onClose,
    description,
    setDescription,
    payrollJournalAccountTypes,
    setPayrollJournalAccountTypes,
    handleUpdate}) 
{
    const [errorState, setErrorState] = useState(false);
    const [type, setType] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const submit = (e) =>{
        if(!description){
            setErrorState(true);
            return;
        }

        if(payrollJournalAccountTypes.length <= 0){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage(`Please add a type`);
            return;
        }

        handleUpdate(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setDescription("");
        setPayrollJournalAccountTypes([]);
        setErrorState(false);
        setIsAddState(false);
    };

    const [isAddState, setIsAddState] = useState(false);
    const addHandleClick = () => {
        setIsAddState(true);
    }
    const saveType = () =>{
        if(payrollJournalAccountTypes.find(i => i.description === type)){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage(`${type} is already added.`);
            return;
        }

        const data = {
            description: type
        }

        setPayrollJournalAccountTypes((prev) => [...prev, data])
        setType("");
        setIsAddState(false);
    }
    const cancelType = () =>{
        setIsAddState(false);
    }
    const removeType = (data) => {
        setPayrollJournalAccountTypes((prev) => prev.filter((i) => i.description !== data.description));
    };

    const generateType = () => {
        return payrollJournalAccountTypes.length > 0 
            ? payrollJournalAccountTypes.map((data) => (
                <div className="row" style={{alignItems: "center", margin: "5px 0"}}>
                    <span>{data.description}</span>
                    <button
                        id="add-family"
                        className="cancel row"
                        onClick={()=>removeType(data)}
                        style={{marginLeft: "10px", height: "20px"}}
                    >
                        remove
                    </button>
                </div>
            ))
            : <span>No type selected</span>;
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Edit Account</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Description</div>
                            <div className="info-item-input">
                                <input
                                id="description"
                                placeholder="Description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !description && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>

                        <div className="popUp-item info-item">
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Types</div>
                            <div className="info-item-input column" style={{padding: "10px"}}>
                                {generateType()}
                            </div>
                        </div>

                        <>
                            {!isAddState &&
                                <button
                                    id="add-family"
                                    className="add row"
                                    onClick={()=>addHandleClick()}
                                >
                                    Add Type
                                </button>
                            }

                            { isAddState &&
                                <>
                                    <div className="popUp-item info-item column">
                                        <div className="info-item-label">Types</div>
                                        <div className="info-item-input">
                                            <TypeSelect type={type} setType={setType}/>
                                        </div>
                                        <span style={{
                                                visibility: (!type && errorState) ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>{"Please fill up this field"}
                                        </span>
                                    </div>
                                    <div className="row">
                                        <button
                                            id="add-family"
                                            className="save row"
                                            onClick={()=>saveType()}
                                        >
                                            Save
                                        </button>
                                        <button
                                            id="add-family"
                                            className="cancel row"
                                            onClick={()=>cancelType()}
                                            style={{marginLeft: "5px"}}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </>
                            }
                        </>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
        </>
    );
}
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "Active":
                setFilterDataIndex(1);
                break;
            case "PlantilyaId":
                setFilterDataIndex(2);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="Active">Active</option>
                <option value="PlantilyaId">Plantilya Id</option>
            </select>
        </div>
    );
};
export function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, editHandleClick, deleteHandleClick }) {
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <>
            <table {...getTableProps()} className='border-collapse'>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                    {...column.getHeaderProps()}
                                    onClick={() => headerClick(column)}
                                    className="sortable-header"
                                >
                                    {`${column.render("Header")} ${
                                        sortHeaderValue.id === column.id
                                            ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                            : ""
                                    }`}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    SetInfo(cell.render("Cell").props.column.Header, 
                                            cell,
                                            editHandleClick,
                                            deleteHandleClick)
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </>
            ) :
            <></>}
        </>
    )
}
function SetInfo(header, _cell, editHandleClick, deleteHandleClick) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if (header === "Request Date") {
    
    const value = _cell.render("Cell").props.value;
    if (!value) {
      return <td>-</td>;
    }

    let date;
    let timeSource;

    if (String(value).includes("T")) {
      // ISO date-time, e.g. 2026-10-23T14:30:00
      date = new Date(value);
      timeSource = date;
    } else if (String(value).includes(":")) {
      // Time only, e.g. 14:30
      date = new Date();

      const [hours, minutes] = String(value)
        .split(":")
        .map((part) => parseInt(part, 10));

      if (
        Number.isNaN(hours) ||
        Number.isNaN(minutes) ||
        hours < 0 ||
        hours > 23 ||
        minutes < 0 ||
        minutes > 59
      ) {
        return <td>-</td>;
      }

      timeSource = new Date();
      timeSource.setHours(hours, minutes, 0, 0);
    } else {
      // Date only
      date = new Date(value);
      timeSource = null;
    }

    if (Number.isNaN(date.getTime())) {
      return <td>-</td>;
    }

    const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;

    let formattedTime = "";

    if (timeSource) {
      const hours = timeSource.getHours();
      const minutes = String(timeSource.getMinutes()).padStart(2, "0");

      if (globalTimeFormat === "Standard Time") {
        const standardHours = hours % 12 || 12;
        const amPm = hours >= 12 ? "PM" : "AM";

        formattedTime = `${standardHours}:${minutes} ${amPm}`;
      } else if (globalTimeFormat === "Military Time") {
        formattedTime = `${String(hours).padStart(2, "0")}:${minutes}`;
      }
    }

    return (
      <td>
        {formattedDate}
        {formattedTime && ` ${formattedTime}`}
      </td>
    );
  }

    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Date Requested"
    ){
        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    if (header === "Types") {
        return (
            <td>
                {value.map((_data) => (
                    <>
                        {_data.description}
                        <br />
                    </>
                ))}
            </td>
        );
    }    

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
export default PayrollJournalAccount
